import React from 'react'
import SliderSlick from 'react-slick'
import './Slider.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

class Slider extends React.Component {
  state = {
    currentItem: this.props.active || 0,
  }

  componentDidMount() {
    this.slider.slickGoTo(this.state.currentItem)
  }

  componentDidUpdate(props, state) {
    if(state.currentItem !== this.state.currentItem) {
      this.props.onChange(this.state.currentItem)
    }
  }

  get isFirst() {
    return this.state.currentItem === 0
  }

  get isLast() {
    return this.slider && (this.state.currentItem + 1) === this.slider.innerSlider.state.slideCount
  }

  handlePrev = e => {
    this.slider.slickPrev()
  }

  handleNext = e => {
    this.slider.slickNext()
  }

  render() {
    const settings = {
      adaptiveHeight: true,
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (current, next) => this.setState({ currentItem: next }),
    }

    return (
      <div className="Steps-slider">
        <div className="Steps-slider-slides">
          <SliderSlick ref={slider => (this.slider = slider)} {...settings}>
            {this.props.children}
          </SliderSlick>
        </div>
        <div className="Steps-slider-arrows">
          <div onClick={this.handlePrev} className={`${this.isFirst ? 'disabled' : ''}`}>Vorige</div>
          <div onClick={this.handleNext} className={`${this.isLast  ? 'disabled' : ''}`}>Volgende</div>
        </div>
      </div>
    )
  }
}

export { Slider }



// WEBPACK FOOTER //
// ./src/content/components/slider/Slider.js